import React, { useRef } from 'react';
import { ImLocation2, ImPhone, ImMail2, ImSkype } from "react-icons/im";
import emailjs from '@emailjs/browser';
import { toast } from 'react-hot-toast';
import Fade from 'react-reveal/Fade';

const Contact = () => {
    const form = useRef();
 const sendEmail = (e) => {
   e.preventDefault(); // prevents the page from reloading when you hit “Send”
 
   emailjs.sendForm('service_9jh35eu', 'template_sittl9f', form.current, 'VCh71CCi7vtjxuJHi')
     .then((result) => {
        toast.success('Thank you for contacting me')
         e.target.reset()
     }, (err) => {
         // show the user an error
         toast.error('Massages not sent')
     });
 };
    return (
        <div id='contact' className='max-w-[1920px] mx-auto lg:px-20 my-16'>
            <Fade bottom cascade>
            <div className='pt-9'>
                        <p className='text-red-500 text-center text-lg pb-2'>RESALAT</p>
                        <h1 className='lg:text-5xl text-3xl font-bold text-center text-[#C4CFDE]'> Contact  Me</h1>
    
                </div>
            <div className="lg:flex lg:justify-center mt-16 gap-20">
                <div className="flex flex-col gap-4 items-center">
                    <p className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl hover:text-red-500 flex items-center gap-3 text-lg'><ImLocation2 className='text-red-500'/> Gaibandha, Rangpur, Dhaka</p>
                    <a href='tel:+8801765975545' className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl hover:text-red-500 flex items-center gap-3 text-lg'><ImPhone className='text-red-500'/>+8801765975545</a>
                    <a href='mailto:resalatislam5@gmail.com' className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl hover:text-red-500 flex items-center gap-3 text-lg'><ImMail2 className='text-red-500'/>resalatislam5@gmail.com</a>
                    <a href='https://www.linkedin.com/in/resalat-islam/' className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl hover:text-red-500 flex items-center gap-3 text-lg' target="blank"><ImLocation2 className='text-red-500'/>Linkedin</a>
                    <a href='https://join.skype.com/invite/ypKerAcWxoyb' className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl hover:text-red-500 flex items-center gap-3 text-lg' target="blank"><ImSkype className='text-red-500'/>Skype</a>
                </div>
                    <h1 className='lg:text-5xl text-3xl font-bold mt-10 mx-5 lg:hidden md:mx-10 text-center'> Contact  <span className='text-red-500'>from</span></h1>
                <div className="w-80 lg:w-96 mt-5 lg:mt-0 mx-auto lg:mx-0">
                <form ref={form} onSubmit={sendEmail}>
                        <input className='bg-gray-900 px-5 py-3 w-80 lg:w-96 mr-8 rounded-xl text-lg' type="text" name="user_name" placeholder='Name' required/>
                        <input className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl text-lg my-5' type="email" name="user_email" placeholder='email' required/>
                        <textarea className='bg-gray-900 px-5 py-3 w-80 lg:w-96 rounded-xl text-lg ' name="message" placeholder='massage' required/>
                        <input className='btn rounded-3xl mt-5 bg-red-500 hover:bg-red-800 border-0 hover:border-0' type="submit" value="Send Massage" />
                    </form>
                </div>
            </div>
            </Fade>
        </div>
    );
};

export default Contact;